module.exports = __webpack_public_path__ + "static/MCU-CenaGala-0a8cbfb6457e9f542234d69974aeb8a5.jpg";